// API configuration
// Ensure there's no trailing slash as axios will add it
const API_URL = (process.env.REACT_APP_API_URL || 'https://meal-planning-api.yocoms1234.workers.dev').replace(/\/$/, '');
export { API_URL }; 
